import React, { ReactElement } from "react";
import PropTypes from "prop-types";

import { Grid } from "@material-ui/core";
import { UserMenu } from "./UserMenu";
import { useHistory } from "react-router-dom";

import styled from "styled-components";
import { LogoIcon } from "./Logo";

const HeaderContainer = styled(Grid)`
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: calc(10px + 2vmin);
  background: white;
  z-index: 1;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.05);
  .search-box {
    text-align: right;
  }
`;

const AmxLogo = styled(LogoIcon)`
  height: 37px;
  width: 140px;
  padding-left: 20px;
  .amx-logo {
    padding-left: 20px;
  }
`;

/**
 * AMX Connect Header Component
 * @component
 */
export const Header = ({
  children,
  currentApp,
  onLogout,
  initials,
  permissions,
}) => {
  const history = useHistory();

  return (
    <HeaderContainer container>
      <Grid item xs={3} style={{ textAlign: "left" }}>
        <AmxLogo onClick={() => history.push("/")} />
      </Grid>
      <Grid item xs={5}>
        {children}
      </Grid>
      <Grid item xs={3}></Grid>

      {initials && onLogout && (
        <UserMenu
          currentApp={currentApp}
          onLogout={onLogout}
          permissions={permissions}
          initials={initials}
        />
      )}
    </HeaderContainer>
  );
};

Header.propTypes = {
  /**
   * Content that will go between the logo and the user menu.
   */
  children: PropTypes.element,
  /**
   * The current App that's using this component
   */
  currentApp: PropTypes.string.isRequired,
  /**
   * Callback function that gets called when the user clicks to log out
   */
  onLogout: PropTypes.func,
  /**
   * The user's initials that will be displayed on the RHS.
   */
  initials: PropTypes.string,
  /**
   * An array containing the user's permissions
   */
  permissions: PropTypes.array.isRequired,
};
